module.exports = __webpack_public_path__ + "img/modal-title.72253cab.jpg";